import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";
import { ExcessMoney } from "../excessMoney/types";

export enum ExcessMoneySettlementTypes {
    //fetch repayment excess money settlement all records
    FETCH_EXCESS_MONEY_SETTLEMENTS = "@@auth/FETCH_EXCESS_MONEY_SETTLEMENTS",
    FETCH_EXCESS_MONEY_SETTLEMENTS_SUCCESS = "@@auth/FETCH_EXCESS_MONEY_SETTLEMENTS_SUCCESS",
    FETCH_EXCESS_MONEY_SETTLEMENTS_ERROR = "@@auth/FETCH_EXCESS_MONEY_SETTLEMENTS_ERROR",

    //fetch repayment excess money settlement by id
    FETCH_EXCESS_MONEY_SETTLEMENT = "@@auth/FETCH_EXCESS_MONEY_SETTLEMENT",
    FETCH_EXCESS_MONEY_SETTLEMENT_SUCCESS = "@@auth/FETCH_EXCESS_MONEY_SETTLEMENT_SUCCESS",
    FETCH_EXCESS_MONEY_SETTLEMENT_ERROR = "@@auth/FETCH_EXCESS_MONEY_SETTLEMENT_ERROR",

    RESET = "@@auth/RESET"
}

export type ExcessMoneySettlementActionDispatch = {
    type:
    | ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS
    | ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT
    | ExcessMoneySettlementTypes.RESET

    payload: any;
}

export type ExcessMoneySettlementReducerDispatch = {
    type:
    | ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS
    | ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS_SUCCESS
    | ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS_ERROR

    | ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT
    | ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT_SUCCESS
    | ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT_ERROR
    | ExcessMoneySettlementTypes.RESET
    payload: {
        data?: FetchApiResponse<ExcessMoneySettlement>;
        error?: string;
    }
}

//use by reducer
export type ExcessMoneySettlementReduxState = {
    loading?: boolean;
    data?: FetchApiResponse<ExcessMoneySettlement>;
    error?: string | null;
}

export type ExcessMoneySettlement = {
    //id: string,
    // financierId: string,
    // creatorUserId: string,
    // approverUserId: string,
    repaymentExcessMoneyId: string,
    actionDate: string,
    action: string,
    paymentInstrumentId: string,
    refundAccountNumber: string,
    refundAccountIfscCode: string,
    amount: number,
    makerRemarks: string,
    checkerRemarks: string,
    status: string,
    createdOn: string,
    updatedOn: string,
    makerUser: MakerUser,
    checkerUser: CheckerUser,
    paymentInstrument: PaymentInstrumentExcessMoneySettlement
}

export type MakerUser = {
    id: string,
    name: string,
    externalId: string
}

export type CheckerUser = {
    id: string,
    name: string,
    externalId: string
}

export type ExcessMoneySettlementRedux = {
    loading?: boolean;
    data?: CreateApiResponse<ExcessMoneySettlement>
    error?: string | null;
}

export type PaymentInstrumentExcessMoneySettlement = {
    id: string,
    instrumentNumber: string,
    fundingAmount: bigint
}

export type FetchExcessMoneySettlementByIdRequest = {
    payload: string;
    type: string;
}

//used by saga
export type FetchExcessMoneySettlementRequest = {
    payload: FilterMetadata,
    type: string
}